"use strict";

define('uikit/elements/text',['underscore', 'marionette', '../mixins/component.mixin', '../channel', '../templates'], function (_, Mn, ComponentMixin, channel, Templates) {
  var TextView = Mn.ItemView.extend(ComponentMixin).extend({
    className: 'text',
    tagName: 'span',
    options: {
      visible: true,
      color: '',
      text: '',
      formatter: null
    },
    update: {
      color: false
    },
    bindings: {},
    template: Templates.UIKit['label'],
    serializeData: function serializeData() {
      var data = ComponentMixin.serializeData.apply(this, arguments);
      if (_.isFunction(this.formatter)) {
        data.text = this.formatter(this.text);
      }
      return data;
    },
    updateAttributes: function updateAttributes() {
      this.addClass(this.getOption('color'), this.getBoolOption('color'));
    }
  });
  channel.reply('text', function () {
    return TextView;
  });
  return TextView;
});

